<template>
<div>
    <CCard>
        <CCardHeader class="bg-primary text-white font-weight-bold d-flex align-items-center justify-content-between">
            Hasil Post Test
            <button class="btn btn-dark" @click="$router.go(-1)">Kembali</button>
        </CCardHeader>
        
    </CCard>
    <CCard>
        <CCardHeader class="bg-primary text-white font-weight-bold">
            Data Peserta
        </CCardHeader>
        <CCardBody>
            
            <CDataTable 
              style="widht:100% !important" 
              :items="items" 
              :fields="fields"
              :items-per-page-select='{ label : "Data Per Halaman", class: "float-right" }'  
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data ..", class: "float-left" }'
              :items-per-page="10"
              :pagination='{ class: "float-right" }'
              hover 
              sorter>
              <template #no="{ index}">
                <td class="py-2">{{ index += 1 }}</td>
              </template>
              <template #no_anggota="{item}">
                <td class="py-2 ">
                  {{ item.no_anggota ? item.no_anggota : '-' }}
                </td>
              </template>
              <template #nilai_post_test="{item}">
                <td class="py-2 ">
                  {{ item.nilai_post_test ? item.nilai_post_test : '0' }}
                </td>
              </template>
              <template #nama_lengkap="{item}">
                <td class="py-2 " v-if="item.tipe_peserta != null">
                  {{ item.nama_instruktur ? item.nama_instruktur : '-' }}
                </td>
                <td class="py-2 " v-else>
                  {{ item.nama_lengkap ? item.nama_lengkap : '-' }}
                </td>
              </template>
              <template #status_mengikuti_post_test="{item}">
                <td class="py-2 text-center font-weight-bold">
                    <span class="text-success font-weight-bold" v-if="item.status_mengikuti_post_test == 'Mengikuti'">
                      Mengikuti
                    </span>
                    <span class="text-warning font-weight-bold" v-else>
                      Belum Mengikuti
                    </span>
                </td>
              </template>         
            </CDataTable>
        </CCardBody>
    </CCard>
</div>
</template>
<script>

import HasilPostTestService from "@/services/pelatihan/posttest/hasil-post-test.service";
import baseUrl from "@/services/base-url"

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { AlertUtils } from "@/mixins/AlertUtils";


const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    sorter: true,
    key: "no_anggota",
    _style: "width:5%; text-align: left",
    label: "No Anggota",
    sorter: true,
    filter: false
  },
  {
    sorter: true,
    key: "nama_lengkap",
    label: "Nama Peserta",
    sorter: true,
    filter: false
  },
  
  {
    sorter: true,
    key: "status_mengikuti_post_test",
    label: "Status",
    sorter: true,
    filter: false
  },
  
  {
    sorter: true,
    key: "nilai_post_test",
    label: "Nilai",
    sorter: true,
    filter: false
  },

 
];

export default {
    mixins : [AlertUtils],
    data() {
        return {
            fields,
            items : []
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });
            HasilPostTestService.getDataPeserta(
                0,
                50000,
                this.$route.params.id_workshop_pelatihan,
                'default'
            ).then(response => {
                this.items = response.data.data.content
                loader.hide()
            }).catch(error => {
                // comment console console.log(error)
                loader.hide()
            })
        },
        
    }
}
</script>